<template>
  <!-- 學生 -> 儲值紀錄 -->
  <dir class="scrollable-container">
    <v-toolbar
      :color="themeColor"
      flat>
      <span class="title">儲值紀錄</span>
    </v-toolbar>

    <v-data-table
      class="data-table"
      no-data-text="查無資料"
      :headers="headers"
      :items="records"
      hide-actions>
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{props.item.chargeDate}}</td>
        <td class="text-xs-right">{{props.item.point}}</td>
      </template>
    </v-data-table>
  </dir>
</template>

<script>
export default {
  data() {
    return {
      headers: [
        {
          text: '日期',
          align: 'left',
          value: 'chargeDate'
        },
        {
          text: '點數',
          align: 'right',
          value: 'point'
        }
      ],
      records: [
        {chargeDate: '2018-10-11', point: 1000},
        {chargeDate: '2018-10-11', point: 1000},
        {chargeDate: '2018-10-11', point: 1000},
        {chargeDate: '2018-10-11', point: 1000},
        {chargeDate: '2018-10-11', point: 1000},
        {chargeDate: '2018-10-11', point: 1000},
        {chargeDate: '2018-10-11', point: 1000},
        {chargeDate: '2018-10-11', point: 1000},
        {chargeDate: '2018-10-11', point: 1000},
        {chargeDate: '2018-10-11', point: 1000},
        {chargeDate: '2018-10-11', point: 1000},
        {chargeDate: '2018-10-11', point: 1000},
        {chargeDate: '2018-10-11', point: 1000},
        {chargeDate: '2018-10-11', point: 1000},
        {chargeDate: '2018-10-11', point: 1000}
      ]
    };
  }
};
</script>

<style lang="stylus" scoped>
.data-table {
  overflow: auto;
  flex-grow: 1;
}

.data-table >>> .v-table__overflow {
  overflow: initial;
}
</style>
